// extracted by mini-css-extract-plugin
export var bubble = "_19-0";
export var container = "_19-f";
export var contrastBorder = "_19-g";
export var greyOut = "_19-2";
export var initialsColor0 = "_19-3";
export var initialsColor1 = "_19-4";
export var initialsColor10 = "_19-d";
export var initialsColor11 = "_19-e";
export var initialsColor2 = "_19-5";
export var initialsColor3 = "_19-6";
export var initialsColor4 = "_19-7";
export var initialsColor5 = "_19-8";
export var initialsColor6 = "_19-9";
export var initialsColor7 = "_19-a";
export var initialsColor8 = "_19-b";
export var initialsColor9 = "_19-c";
export var initialsWrapper = "_19-1";
export var large = "_19-l";
export var medium = "_19-k";
export var mediumSmall = "_19-j";
export var mediumSmallMedium = "_19-o";
export var micro = "_19-h";
export var small = "_19-i";
export var tiny = "_19-n";
export var xTiny = "_19-m";